import { render, staticRenderFns } from "./UnifiedAdd.vue?vue&type=template&id=1489b578&"
import script from "./UnifiedAdd.vue?vue&type=script&lang=js&"
export * from "./UnifiedAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports